import { Component } from '@angular/core';

@Component({
  selector: 'empathy-carousel-description',
  templateUrl: 'carousel-description.component.html',
  styleUrls: ['./carousel-description.component.scss']
})
export class CarouselDescriptionComponent {}
